export const API_TAG = 'configurator'

export const PRECISION_NUMBER = 6
